<template>
  <div class="common-layout">
    <el-aside width="200px" class="aside">
      <div class="siteName">
        <img src="../../../assets/logo2.png" />
        <span>后台系统</span>
      </div>
      <el-row class="tac">
        <el-col :span="24">
          <!-- 左侧导航栏 -->
          <el-menu 
            :router="true"
            default-active="1"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            background-color="#ebf1f5"
            text-color="#606266"
            active-text-color="#2F74FF"
            :style="{height:clientHeight-60+'px'}"
          >

            <el-menu-item :style="{'background':'#ddd','fontWeight':700,'borderBottom':'1px solid #ccc'}" :class="navSelect==2?'selected':''" @click="navClick(2)">
              <el-icon><HomeFilled /></el-icon>
              <span>系统设置</span>
              <img src="../../../assets/icon-down.png" class="icon-angle-down" />
            </el-menu-item>
            <el-menu-item class="sub-menu" index="/admin/RolesList" v-if="navSelect==2">
              <el-icon><UserFilled /></el-icon>
              <span>角色管理</span>
            </el-menu-item>
            <el-menu-item class="sub-menu" index="/admin/AdminsList" v-if="navSelect==2">
              <el-icon><Avatar /></el-icon>
              <span>管理员管理</span>
            </el-menu-item>
            <el-menu-item index="/Admin/SchoolsList" class="sub-menu" v-if="navSelect==2">
              <el-icon><School /></el-icon>
              <span>学校管理</span>
            </el-menu-item>
            <el-menu-item class="sub-menu" index="/admin/CategorysList" v-if="navSelect==2">
              <el-icon><CollectionTag /></el-icon>
              <span>圈子管理</span>
            </el-menu-item>
            <el-menu-item class="sub-menu" index="/Admin/InterestsList" v-if="navSelect==2">
              <el-icon><Tools /></el-icon>
              <span>兴趣爱好</span>
            </el-menu-item>
            <el-menu-item index="/Admin/VipLevelsList" class="sub-menu" v-if="navSelect==2">
              <el-icon><Star /></el-icon>
              <span>VIP等级</span>
            </el-menu-item>
            <el-menu-item index="/Admin/VipPricesList" class="sub-menu" v-if="navSelect==2">
              <el-icon><Star /></el-icon>
              <span>VIP价格</span>
            </el-menu-item>
            <el-menu-item index="/Admin/RechargePricesList" class="sub-menu" v-if="navSelect==2">
              <el-icon><Star /></el-icon>
              <span>充值价格</span>
            </el-menu-item>
            <el-menu-item index="/Admin/DriftBottleTypesList" class="sub-menu" v-if="navSelect==2">
              <el-icon><CollectionTag /></el-icon>
              <span>漂流瓶类型</span>
            </el-menu-item>
            <el-menu-item index="/Admin/DriftBottlesList" class="sub-menu" v-if="navSelect==2">
              <el-icon><CollectionTag /></el-icon>
              <span>漂流瓶设置</span>
            </el-menu-item>
            <el-menu-item index="/Admin/AdminLogsList" class="sub-menu" v-if="false && navSelect==2">
              <el-icon><Tools /></el-icon>
              <span>后台操作日志</span>
            </el-menu-item>
            <el-menu-item index="/Admin/SiteConfigEdit" class="sub-menu" v-if="navSelect==2">
              <el-icon><Tools /></el-icon>
              <span>站点配置</span>
            </el-menu-item>

            
            <el-menu-item :style="{'background':'#ddd','fontWeight':700,'borderBottom':'1px solid #ccc'}" :class="navSelect==3?'selected':''" @click="navClick(3)">
              <el-icon><UserFilled /></el-icon>
              <span>会员管理</span>
              <img src="../../../assets/icon-down.png" class="icon-angle-down" />
            </el-menu-item>

            <el-menu-item class="sub-menu" index="/admin/UsersList" v-if="navSelect==3">
              <el-icon><UserFilled /></el-icon>
              <span>会员列表</span>
            </el-menu-item>
            <el-menu-item index="/Admin/MeiliLogsList" class="sub-menu" v-if="navSelect==3">
              <el-icon><Coin /></el-icon>
              <span>魅力值记录</span>
            </el-menu-item>
            <el-menu-item index="/Admin/RewardLogsList" class="sub-menu" v-if="navSelect==3">
              <el-icon><Coin /></el-icon>
              <span>佣金记录</span>
            </el-menu-item>
            <el-menu-item index="/Admin/CoinLogsList" class="sub-menu" v-if="navSelect==3">
              <el-icon><Coin /></el-icon>
              <span>邮票记录</span>
            </el-menu-item>
            <el-menu-item index="/Admin/RechargeLogsList" class="sub-menu" v-if="navSelect==3">
              <el-icon><Coin /></el-icon>
              <span>充值记录</span>
            </el-menu-item>
            <el-menu-item index="/Admin/VipLogsList" class="sub-menu" v-if="navSelect==3">
              <el-icon><Coin /></el-icon>
              <span>VIP开通记录</span>
            </el-menu-item>
            <el-menu-item index="/Admin/VipRechargeLogsList" class="sub-menu" v-if="navSelect==3">
              <el-icon><Tools /></el-icon>
              <span>VIP充值记录</span>
            </el-menu-item>
            <el-menu-item index="/Admin/SignsList" class="sub-menu" v-if="navSelect==3">
              <el-icon><Location /></el-icon>
              <span>签到记录</span>
            </el-menu-item>
            <el-menu-item index="/Admin/WithdrawLogsList" class="sub-menu" v-if="navSelect==3">
              <el-icon><Coin /></el-icon>
              <span>提现记录</span>
            </el-menu-item>



            <el-menu-item :style="{'background':'#ddd','fontWeight':700,'borderBottom':'1px solid #ccc'}" :class="navSelect==4?'selected':''" @click="navClick(4)">
              <el-icon><Message /></el-icon>
              <span>信箱管理</span>
              <img src="../../../assets/icon-down.png" class="icon-angle-down" />
            </el-menu-item>
            <el-menu-item index="/Admin/MailsList" class="sub-menu" v-if="navSelect==4">
              <el-icon><Message /></el-icon>
              <span>信箱列表</span>
            </el-menu-item>
            <el-menu-item index="/Admin/DriftBottleLogsList" class="sub-menu" v-if="navSelect==4">
              <el-icon><Message /></el-icon>
              <span>漂流瓶日志</span>
            </el-menu-item>

            <el-menu-item :style="{'background':'#ddd','fontWeight':700,'borderBottom':'1px solid #ccc'}" :class="navSelect==5?'selected':''" @click="navClick(5)">
              <el-icon><Grid /></el-icon>
              <span>广场管理</span>
              <img src="../../../assets/icon-down.png" class="icon-angle-down" />
            </el-menu-item>
            <el-menu-item index="/Admin/OfferRewardsList" class="sub-menu" v-if="navSelect==5">
              <el-icon><Grid /></el-icon>
              <span>悬赏任务</span>
            </el-menu-item>
            <el-menu-item index="/Admin/CirclesList" class="sub-menu" v-if="navSelect==5">
              <el-icon><Tools /></el-icon>
              <span>圈子列表</span>
            </el-menu-item>

            <el-menu-item :style="{'background':'#ddd','fontWeight':700,'borderBottom':'1px solid #ccc'}" :class="navSelect==6?'selected':''" @click="navClick(6)">
              <el-icon><Grid /></el-icon>
              <span>投诉管理</span>
              <img src="../../../assets/icon-down.png" class="icon-angle-down" />
            </el-menu-item>
            <el-menu-item index="/Admin/ToususList" class="sub-menu" v-if="navSelect==6">
              <el-icon><Tools /></el-icon>
              <span>投诉处理</span>
            </el-menu-item>

          </el-menu>
        </el-col>
      </el-row>
    </el-aside>
    
    <!-- 主内容排列 -->
    <el-container>
      <div class="page_top">
        <div class="logoutBtn" @click="logout">退出系统</div>
        <div class="page_username">欢迎您，<span style="color:red;">{{userName}}</span></div>
        <img src="../../../assets/headpic.jpeg" />
      </div>
      <el-main class="rightContent">
        <router-view></router-view>
      </el-main>
      <el-footer></el-footer>
    </el-container>
  </div>
</template>

<script scoped>
  export default {
    data(){
      return {
        navSelect : 1,
        clientHeight: document.documentElement.clientHeight,
        userName : ''
      }
    },
    mounted:function(){
      let userInfo = this.$store.getters.getUser
      this.userName = userInfo.username
      var tmpNavSelect = window.localStorage.CACHE_NavSelect;
      if(tmpNavSelect){
        this.navSelect = parseInt(tmpNavSelect)
      }
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      logout() {
        var ths = this
        this.$post("/auth/logout",{})
        .then(function (res) { 
          if(res.success){
            ths.$store.dispatch("logout")
            ths.$router.push("/login")
          }else{
            alert(res.msg);
          }
        })
        .catch(function (err) {
          console.log(err)
        })
      },
      navClick(navId){
        this.navSelect = navId
        window.localStorage.CACHE_NavSelect = navId
      },
      // 获取cookie
      getCookie: function (key) {
          return window.localStorage.getItem(key);
      },
    }
  }

</script>

<style>
.common-layout{
  height: 100%;
  display:grid;
  grid-template-columns:200px auto;
}
.el-menu-vertical-demo{
  height: 100%;
}
html,
body,
#app,
.aside{
  height: 100%;
}
.el-breadcrumb{
  padding:10px 20px!important;
  border-bottom:1px solid #ccc;
  padding:10px 0;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
}
.el-breadcrumb .el-breadcrumb__item{
  height:30px;
  line-height:30px;
}
.common-layout .el-aside{
  background:#304156;
}
.common-layout .siteName{
  background:#304156;
  line-height:50px;
  color:white;
  overflow:hidden;
}
.common-layout .siteName img{
  width:30px;
  height:30px;
  margin:10px;
  float:left;
}
.common-layout .siteName span{
  float:left;
  color:white!important;
  font-weight:700;
}
.common-layout .tac{
  background:#304156;
}
.common-layout .el-menu{
  background:#304156;
  border:none;
}
.common-layout .el-menu .el-menu-item{
  display:block;
  overflow:hidden;
  background:#304156!important;
  border:none!important;
  font-weight:400!important;
  color:#BFCBD9;
  height:60px;
  padding:15px 0;
  line-height:30px;
}
.common-layout .el-menu .el-menu-item.selected{
  color:#409EFF;
}
.common-layout .el-menu .el-menu-item.sub-menu{
  background:#1F2D3D!important;
  padding-left:40px;
}

.common-layout .el-menu .el-menu-item .icon-angle-down{
  width:20px;
  height:20px;
  float:right;
  margin-top:5px;
  margin-right:20px;
}
.common-layout .el-menu .el-menu-item.selected .icon-angle-down{
  transform: rotate(180deg);
  transition: transform 0.5s ease; /* 可选：添加平滑过渡效果 */
}



.rightContent{
  padding:0!important;
}
html .is-always-shadow{
  box-shadow:none!important;
  border:none;
}

.page_top{
  height: 50px;
  overflow:hidden;
  padding-right:20px;
  position: fixed;
  top:0;
  right:0;
}
.page_top img{
  width:40px;
  height:40px;
  float:right;
  margin-top:5px;
  border-radius:10px;
}
.page_top .page_username{
  float:right;
  line-height:50px;
  font-size:12px;
  padding:0 15px;
  font-weight:700;
}
.page_top .logoutBtn{
  float:right;
  line-height:50px;
  font-size:12px;
  cursor:pointer;
}
.el-table thead th{
  background:#f8f8f9!important;
  height:50px!important;
  border-bottom: 1px solid #dfe6ec;
  color: #515a6e;
  text-align:center!important;
}
.el-table td{
  height:50px!important;
  text-align:center!important;
}
.el-text{
  font-size: 14px!important;
  color: #606266!important;
  font-weight:700;
}
.el-card{
  margin-top:5px;
}
.el-card__body{
}
.kh-page{
  padding: 30px 0;
}
</style>
